module.exports = __webpack_public_path__ + "img/skyblueBg.fc409e0b.png";